import React from "react";

const AirDropIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="#F8F9F9"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.00012207" width="32" height="32" rx="16" fill="#F8F9F9" />
      <g clipPath="url(#clip0_321_8926)">
        <path
          d="M16.1547 19.0159H16.8155L18.362 13.9825C19.0228 13.1952 20.5624 13.2585 20.5624 13.2585C22.4042 13.2585 22.4042 14.1794 22.4042 14.1794L17.7364 19.0159L18.1933 19.4729L23.1916 14.313C23.1916 14.313 22.9947 8.00012 15.5993 8.00012C8.20387 8.00012 8 14.313 8 14.313L12.9982 19.4729L13.4552 19.0159L8.78735 14.1794C8.78735 14.1794 8.78735 13.2585 10.6292 13.2585C10.6292 13.2585 12.1757 13.1952 12.8295 13.9825L14.3761 19.0159H15.0369L13.6591 13.9825C13.6591 13.9825 13.891 13.2233 15.5993 13.2233C15.5993 13.2233 17.188 13.2374 17.6731 13.9474L16.1547 19.0159Z"
          fill="#002035"
        />
        <path
          d="M17.4279 19.754H13.7724C13.6107 19.754 13.4771 19.8876 13.4771 20.0493V23.7048C13.4771 23.8665 13.6107 24.0001 13.7724 24.0001H17.4279C17.5896 24.0001 17.7232 23.8665 17.7232 23.7048V20.0493C17.7161 19.8876 17.5896 19.754 17.4279 19.754ZM15.579 21.6872C15.8321 21.7083 16.0571 21.7083 16.2539 21.8911C16.4789 22.102 16.5492 22.4394 16.4226 22.7206C16.3523 22.8753 16.2258 22.9948 16.0711 23.0792C16.05 23.0932 15.8321 23.1705 15.8321 23.1846C15.8321 23.2057 15.8321 23.508 15.8321 23.508H15.3119C15.3119 23.3885 15.3119 23.269 15.3119 23.1495C14.7917 23.1143 14.7214 22.4535 14.7214 22.4535C14.869 22.4535 15.0096 22.4535 15.1573 22.4535C15.1783 22.4535 15.2486 22.6011 15.2697 22.6222C15.3189 22.6714 15.3892 22.7066 15.4666 22.7206C15.6001 22.7488 15.7618 22.7277 15.8813 22.6574C15.9587 22.6082 16.029 22.5308 16.029 22.4394C16.036 22.2145 15.797 22.1442 15.6142 22.1231C15.2627 22.0809 14.9323 21.9825 14.7847 21.624C14.6792 21.3639 14.7284 21.0405 14.9393 20.8437C15.0167 20.7734 15.108 20.7171 15.2065 20.6749C15.2135 20.6749 15.333 20.6328 15.333 20.6328V20.2461H15.8321V20.5906C16.3734 20.6539 16.4859 21.3006 16.4859 21.3006L16.036 21.3076C16.036 21.2022 15.9727 21.1178 15.8813 21.0756C15.811 21.0405 15.7337 21.0335 15.6634 21.0264C15.5931 21.0194 15.5228 21.0264 15.4525 21.0405C15.3119 21.0756 15.1994 21.2022 15.1994 21.3568C15.1854 21.5888 15.3752 21.6732 15.579 21.6872Z"
          fill="#002035"
        />
      </g>
      <defs>
        <clipPath id="clip0_321_8926">
          <rect width="16" height="16" fill="#002035" transform="translate(8 8.00012)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AirDropIcon;
